import { copyText } from 'src/constants/copy/copy.utils';

/** @type {import('./copy.utils').CopyEntry} */
export const SIDEBAR_AGENCY_SELECTOR_LABEL = {
    defaultMessage: 'Agency: {agency}',
    id: 'SIDEBAR.AGENCY_SELECTOR.LABEL',
};

/**
 * Accessible name for the sidebar agency selector, naming the selected agency.
 * @param {string} agency
 * @returns {string}
 */
export const getSidebarAgencySelectorLabel = (agency) => (
    copyText(SIDEBAR_AGENCY_SELECTOR_LABEL).replace('{agency}', agency)
);
